import phoneMetaData from '../../config/phone-metadata.min.json';

const { countries } = phoneMetaData;

export default Object.keys(countries);
